import { useEffect, useState } from 'react'
import type { BusinessUnitCode } from '~/model'

export type TranslationContext = { context?: 'ccc' | 'be' }

const buToTranslationContext = (bu: BusinessUnitCode): TranslationContext => {
  switch (bu) {
    case 'ccc':
      return { context: 'ccc' }
    case 'dhl-be':
      return { context: 'be' }
    default:
      return {}
  }
}

export const useTranslationContext = (businessUnit: BusinessUnitCode): TranslationContext => {
  const initialTranslationContext = buToTranslationContext(businessUnit)
  const [context, setContext] = useState(initialTranslationContext)

  useEffect(() => {
    setContext(buToTranslationContext(businessUnit))
  }, [businessUnit])

  return context
}
